__turbopack_context__.v({
  "active": "BrochureModal-module-scss-module__sbXFDa__active",
  "error": "BrochureModal-module-scss-module__sbXFDa__error",
  "modalWrapper": "BrochureModal-module-scss-module__sbXFDa__modalWrapper",
  "privacyPolicy": "BrochureModal-module-scss-module__sbXFDa__privacyPolicy",
  "wrapper": "BrochureModal-module-scss-module__sbXFDa__wrapper",
});
